import { render, staticRenderFns } from "./AddEditPayGrade.vue?vue&type=template&id=47a937ae"
import script from "./AddEditPayGrade.vue?vue&type=script&lang=js"
export * from "./AddEditPayGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports